module.exports = __webpack_public_path__ + "img/AttendanceTypes.105841cc.svg";